<ng-container *ngIf="action$ | async as action">
    <p-button
      icon="pi pi-hidden"
      [ngClass]="action.name"
      [label]="action.description"
      ntapDebounceClick
      (onClick)="executeAction($event)"
      [disabled]="(isDisabled$ | async) ?? true"
      [pTooltip]="action.tooltip ?? ''"
      tooltipPosition="left"
    ></p-button>
  </ng-container>
  
  
  <p-dialog
    *ngIf="showDialog"
    [resizable]="false"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    appendTo="body"
    styleClass="custom-small-dialog"
  >
    <ng-template pTemplate="header">
      <h3>Zaključenje predmeta </h3>
    </ng-template>
  
    <div class="field md:flex gap-2 align-items-center" [formGroup]="razlogFg">
      <label for="razlog" class="property-label">Napomena o zaključenju predmeta</label>
  
      <textarea rows="5" cols="50" pInputTextarea formControlName="razlog" [autoResize]="true"></textarea>
    </div>
  
    <ng-template pTemplate="footer">
      <div class="flex">
        <p-button (onClick)="closeDialog()">Odustani</p-button>
        <p-button (onClick)="confirmRejection()">Potvrdi</p-button>
      </div>
    </ng-template>
  </p-dialog>
  